export default "__VITE_ASSET__DOeZzFui__"